function isLastOrderCollectedOrCancelledOrDelivered(status, bookingStatus) {
    return (status !== 'Collected' && status !== 'Cancelled' && bookingStatus !== 'Delivered');
}

function OrderTrackerService($rootScope, $state, shopperService, $timeout) {
    this.$state = $state;
    this.shopperService = shopperService;
    this.$timeout = $timeout;

    this.lastOrder = {};
    this.isOpen = false;
    this.isEnabled = false;

    // on state change, check if the order tracker is open by default on this state or disabled by default
    $rootScope.$on('$stateChangeSuccess', () => {
        this.initIsOpenAndEnabled();
    });

    // when the user log we  check if the order tracker is enabled depending of his orders
    $rootScope.$on('login:success', () => {
        this.checkEnabled();
    });

    $rootScope.$on('shopper:init', () => {
        if (!this.shopperService.IsGuest) {
            this.initIsOpenAndEnabled();
        }
    });
}

OrderTrackerService.prototype.initIsOpenAndEnabled = function () {

    const bookingStatus = this.lastOrder.DeliveryBookingList
                          && this.lastOrder.DeliveryBookingList.length
                            ? this.lastOrder.DeliveryBookingList[0].BookingStatus
                            : null;

    this.isOpen = ((this.$state.current.data && this.$state.current.data.openOrderTracker === true)
                    && this.shopperService.recentOrders
                    && this.shopperService.recentOrders.OrderId
                    && isLastOrderCollectedOrCancelledOrDelivered(this.lastOrder.Status, bookingStatus));
    this.checkEnabled();
};

OrderTrackerService.prototype.checkEnabled = function () {
    // this function can be triggered when there is no digest cycle
    // we need to trigger a digest cycle for the directives to update
    this.$timeout(() => {
        // if the default value fo this state is set to hidden
        // or if the user is not logged then set isEnabled to false
        if ((this.$state.current.data && this.$state.current.data.disableOrderTracker === true) || this.shopperService.currentUser.isGuest) {
            this.isEnabled = false;
        } else {
            // if the shopper have at least an order in process
            this.lastOrder = this.shopperService.recentOrders;

            const bookingStatus = this.lastOrder.DeliveryBookingList
            && this.lastOrder.DeliveryBookingList.length
                ? this.lastOrder.DeliveryBookingList[0].BookingStatus
                : null;

            this.isEnabled = this.lastOrder && this.lastOrder.OrderId
                && !!isLastOrderCollectedOrCancelledOrDelivered(this.lastOrder.Status, bookingStatus);
        }
    }, 0, true);
};

OrderTrackerService.prototype.toogle = function () {
    this.isOpen = !this.isOpen;
};

OrderTrackerService.prototype.trigger = function (open) {
    this.isOpen = open;
};

module.exports = OrderTrackerService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/order-tracker/order-tracker-service.js
 **/